const ScanLines = () => {
  return (
    <>
      {/* Horizontal scan lines */}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <div
          className="absolute w-full h-px bg-gradient-to-r from-transparent via-cyan-400 to-transparent animate-scan"
          style={{
            boxShadow: '0 0 10px rgba(6, 182, 212, 0.5)',
          }}
        />
      </div>

      {/* Static scan line texture */}
      <div
        className="absolute inset-0 pointer-events-none opacity-5"
        style={{
          backgroundImage: `repeating-linear-gradient(
            0deg,
            transparent,
            transparent 2px,
            rgba(255, 255, 255, 0.1) 2px,
            rgba(255, 255, 255, 0.1) 4px
          )`,
        }}
      />
    </>
  );
};

export default ScanLines;
